import { useSelector } from 'react-redux'

import { getMenuMeta } from 'selectors/menu-metadata/getMenuMeta'

export const useMenuMeta = () => useSelector(getMenuMeta)
